import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IUserFullProfile } from '@model/userFullProfile';

import { apiClient } from '@services/apiClient';

import { selectAppPersistRefreshInterval } from '@store/useAppStorePersist';

export const userFullProfileKey = () => ['userFullProfile'];
export const userFullProfileFn = () =>
  apiClient.get(`${APP_SSO_URL}api/user/profile`, { params: { clientId: 2 } });

const userFullProfileSelect = ({ data }: AxiosResponse<IUserFullProfile>) => {
  return {
    user: data.user,
    customer: data.customer,
    simpleEventsDictionary: data.simpleEventsDictionary || [],
  };
};

export const useUserFullProfileQuery = () => {
  const refreshInterval = selectAppPersistRefreshInterval();

  return useQuery({
    queryKey: userFullProfileKey(),
    queryFn: userFullProfileFn,
    refetchInterval: refreshInterval,
    select: userFullProfileSelect,
  });
};
